import React, { useState, useCallback } from 'react';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import { ToasterContext } from './ToasterContext';

import './toaster.scss';

interface IToasterProps {
  children: any;
  [key: string]: any;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const Toaster: React.FunctionComponent<IToasterProps> = ({
  type,
  children, ...props
}) => {
  const [toast, setToast] = useState<any>(null);
  const addToast = useCallback(
    (toast: any) => {
      setToast(toast);
    },
    [setToast]
  );

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setToast(null);
  };

  return (
    <ToasterContext.Provider value={{ addToast }}>
      {children}
      <Stack
        spacing={2}
        sx={{ width: '100%' }}
        {...props}
      >
        <Snackbar open={!!toast} autoHideDuration={10000} onClose={handleClose}
          anchorOrigin={{
          vertical: "top",
          horizontal: "right"
          }}
        >
          <Alert onClose={handleClose} severity={toast?.type} sx={{ width: '100%', maxWidth: '450px' }}>
            {toast?.title}
          </Alert>
        </Snackbar>
      </Stack>
    </ToasterContext.Provider>
  );
}
